export default {
  API_URL_CATALOGO: `${import.meta.env.VITE_API_URL}/c/api/v1/`,
  API_URL_CONFIG_PORTAL: `${import.meta.env.VITE_API_URL}/p/api/v1/`,
  API_URL_LOGISTICA_PEDIDO: `${import.meta.env.VITE_API_URL}/l/api/v1/`,
  API_URL_TEMPLATE: `${import.meta.env.VITE_API_URL}/t/api/v1/`,
  API_URL_VENTAS: `${import.meta.env.VITE_API_URL}/v/api/v1/`,
  API_URL_AGGREGATOR: `${import.meta.env.VITE_API_URL}/api/v1/`,
  API_URL_MARKETING: `${import.meta.env.VITE_API_URL}/mk/api/v1/`,
  API_URL_PERSONALIZACION: `${import.meta.env.VITE_API_URL}/pe/api/v1/`,
  API_URL_PAYMENT: `${import.meta.env.VITE_API_URL}/pa/api/v1/`,
  API_URL_COMERCIANTES: `${import.meta.env.VITE_API_URL}/m/api/v1/`,
  API_URL_REPORTES: `${import.meta.env.VITE_API_URL}/re/api/v1/`,
  API_URL_USUARIOS_MANAGER: `${import.meta.env.VITE_API_URL}/u/api/v1/`,
  API_URL_AVATARES: `${import.meta.env.VITE_API_URL}/av/api/avatar/`,
  API_URL_SIGNAL_R_VENTA: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/ventashub`,
  API_URL_SIGNAL_R_NOTIFICATION: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/notificationhub`,
  API_URL_SIGNAL_R_MRWRECLAMACION: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/mrwreclamacioneshub`,
  API_URL_SIGNAL_R_VENTA_ITEMS: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/ventaitemshub`,
  API_URL_SIGNAL_R_TRANSMITIR: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/transmitirhub`,
  API_URL_SIGNAL_R_PERSONALIZACION_FAMILIAS: `${import.meta.env.VITE_API_SIGNAL_R_PERSONALIZACION}/hub/familiashub`,
  API_URL_SIGNAL_R_PERSONALIZACION_FONDOS_FAMILIA: `${import.meta.env.VITE_API_SIGNAL_R_PERSONALIZACION}/hub/fondofamiliahub`,
  API_URL_SIGNAL_R_REPORTES_IMPRIMIT_PMT: `${import.meta.env.VITE_API_SIGNAL_R_REPORTES}/hub/imprimirpmthub`,
  API_URL_SIGNAL_R_NOTIFICACIONES_WHATSAPP: `${import.meta.env.VITE_API_SIGNAL_R_NOTIFICACIONES}/hub/whatsapphub`,
  API_URL_SIGNAL_R_NOTIFICACIONES_EMAILS_RESENA: `${import.meta.env.VITE_API_SIGNAL_R_NOTIFICACIONES}/hub/whatsapphub`,
  API_URL_SIGNAL_R_WEBSHOPPING_GENERAR_MAPA: `${import.meta.env.VITE_API_SIGNAL_R_WEBSHOPPING}/hub/webshoppinghub`,
  API_URL_SIGNAL_R_AMAZON: `${import.meta.env.VITE_API_SIGNAL_R_VENTAS}/hub/amazonhub`,
  API_URL_JOBS: `${import.meta.env.VITE_API_URL}/jb/api/v1/`,
  API_URL_SYNC: `${import.meta.env.VITE_API_URL}/sy/api/v1/`,
  API_URL_REVIEWS: `${import.meta.env.VITE_API_URL}/rw/api/v1/`,
  // El email gateway no versiona con /api/v1: sus rutas son /api/campaigns, /api/suppressions, etc.
  API_URL_EMAIL_GATEWAY: `${import.meta.env.VITE_API_URL}/eg/api/`,
  CATEGORIA_PERSONALIZADA_ID: 3,
  TIPO_BIBLIOTECA_SVG_AMAZON: 4,
  // Si la pregunta del diseño de Amazon que contiene este texto se responde "no",
  // el cliente no ha pedido personalización y no se muestra el diseño.
  PREGUNTA_AMAZON_PERSONALIZAR: 'perso',
}
